import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AIState {
  pageId: string; //path name current. ex: /dashboard/0, /today, /setting/system/users,...
  lastOnMouseClicked: any; //object last click nearest
  copiedText: any; // clipboard text memory
  messageInit: string;
  params: any;
}

const initialState: AIState = {
  pageId: "",
  lastOnMouseClicked: {},
  copiedText: undefined,
  messageInit: "",
  params: undefined
};

const AISlice = createSlice({
  name: "ai",
  initialState,
  reducers: {
    //push a page id to store. Use when pathName change state
    pushPageId: (state, action: PayloadAction<string>) => {
      state.pageId = action.payload;
    },
    //push clipboard to store. Use when user using ctrl + V or copy event
    pushCopiedText: (state, action: PayloadAction<any>) => {
      state.copiedText = action.payload;
    },

    //push a last clicked mouse to store. Use when user click a element
    pushLastOnMouseClicked: (state, action: PayloadAction<any>) => {
      state.lastOnMouseClicked = action.payload;
    },
    backendInitChat: (state, action: PayloadAction<string>) => {
      state.messageInit = action.payload;
    },
    pushParams: (state, action: PayloadAction<any>) => {
      state.params = action.payload;
    },
    clearParams: (state) => {
      state.params = initialState.params;
    }
  }
});
export const { pushPageId, pushCopiedText, pushLastOnMouseClicked, backendInitChat, pushParams, clearParams } =
  AISlice.actions;
export default AISlice.reducer;
